import {
    SET_ASSET_ASSOCIATIONS,
    SET_ASSET_ASSOCIATIONS_METADATA,
    SET_ASSET_ASSOCIATIONS_RECORD,
    SET_ASSET_ASSOCIATIONS_LOADING,
} from "../types";

const initialState = {
    associations: [],
    metadata: {
        all_relationships_associations: [],
        asset_associations_relationship: []
    },
    record: {},
    loading: false,
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_ASSET_ASSOCIATIONS:
            return {
                ...state,
                associations: payload
            };
        case SET_ASSET_ASSOCIATIONS_METADATA:
            return {
                ...state,
                metadata: payload
            };
        case SET_ASSET_ASSOCIATIONS_RECORD:
            return {
                ...state,
                record: payload,
            };
        case SET_ASSET_ASSOCIATIONS_LOADING:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
}